<template>
  <div>
    <page-container title="Доступные сессии" noSteps white>

      <div class="filters">
        <div class="filters__left">
          <div class="filters__item">
            <el-select
                v-model="selectDepartment"
                @change="loadVisitList">
              <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.title"
                  :value="item">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="filters__right">
          <div class="total">Всего записей: <b class="total__count">{{ visitsList.length }}</b></div>
        </div>
      </div>

      <el-alert
          v-if="!selectDepartment"
          title="Пожалуйста, выберите центр"
          type="info"
          :closable="false"
          class="tip"
          show-icon>
      </el-alert>
      <template v-else>
        <el-table :data="visitsList" v-loading="loading" @row-click="openConfirm" class="zebra-table">
          <el-table-column width="70" prop="" label="">
            <template slot-scope="scope">
              <letters-avatar v-if="scope.row.user" :name="scope.row.user.name" size="32" type="mini"/>
            </template>
          </el-table-column>

          <el-table-column prop="type" label="Клиент">
            <template slot-scope="scope">
              <div class="user-data">
                <div class="user-data__name">{{ scope.row.user.name }}</div>
                <div class="user-data__phone">{{ scope.row.user.phone }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="user.id" label="ID пользователя"></el-table-column>
          <el-table-column sortable label="Время визита">
            <template slot-scope="scope">
              {{ $root.timeIso(scope.row.date_start) }} - {{ $root.timeIso(scope.row.date_end) }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="user.visit_plus_number" label="Прием"></el-table-column>
          <el-table-column width="50" label="" align="right">
            <template slot-scope="scope">
              <div @click.stop="openCommentModal(scope.row)" class="el-icon-edit edit-icon"></div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            v-if="showPagination"
            class="pagination"
            background
            layout="prev, pager, next"
            :page-size="pagination.per_page"
            :total="pagination.total"
            :current-page="pagination.current_page"
            @current-change="loadVisitList"
        ></el-pagination>

      </template>

      <open-visit-modal
          :selectUser="selectUser"
          @openSession="openSession"
          :visible="openSessionModal"
          @close="openSessionModal = false"/>

      <open-visit-comment-modal
          :selectUser="selectUser"
          :visible="isOpenCommentModal"
          @close="isOpenCommentModal = false"/>

      <el-dialog
          :visible.sync="dialogVisible"
          width="560px">

        <div slot="title">
          <div class="el-dialog__title">Начало визита</div>
          <div class="el-dialog__subtitle">Чтобы начать работу с визитом, подтвердите отправку SMS клиенту
          </div>
        </div>

        <footer-buttons>
          <el-button type="primary"
                     @click="goVisit"
                     :disabled="loading">Отправить
          </el-button>
          <el-button @click="dialogVisible = false">Отменить</el-button>
        </footer-buttons>

      </el-dialog>
    </page-container>
  </div>

</template>

<script>
import Vue from "vue"
import VueMask from "v-mask"
import {mapActions, mapMutations} from "vuex"

import OpenVisitModal from "@/views/cpanel/visit/modal/VisitSession"
import OpenVisitCommentModal from "@/views/cpanel/visit/modal/VisitComment"
import PageContainer from "@/components/elements/PageContainer"
import LettersAvatar from "@/components/elements/LettersAvatar"
import FooterButtons from "@/components/dialog/FooterButtons"

Vue.use(VueMask)

export default {
  name: "OpenLight",
  data: function () {
    return {
      visitsList: [],
      pagination: null,
      modalDevice: null,
      visibleCloseSessionModal: false,
      loading: false,
      openSessionModal: false,
      isOpenCommentModal: false,
      selectUser: null,
      selectDepartment: null,
      activeUser: null,
      departmentList: {},
      dialogVisible: false

    };
  },
  components: {
    OpenVisitModal,
    PageContainer,
    LettersAvatar,
    FooterButtons,
    OpenVisitCommentModal
  },
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page;
      } else return false;
    },

  },
  created() {
    this.checkCurrent()

    this.setStageVisit(0)
  },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE"
    }),
    ...mapMutations({
      setSession: "session/SET_SESSION",
    }),
    openCommentModal(user) {
      this.selectUser = user

      this.isOpenCommentModal = true
    },
    checkCurrent() {
      this.$api.session
          .current()
          .then((response) => {
            if (response.data.id) this.openModalCurrentSession()
            else this.loadDepartments()
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка сессий 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.pageLoading(false)
            this.loading = !!1
          })
    },
    loadVisitList() {
      this.loading = true

      let params = {
        params: {
          department_id: this.selectDepartment.id
        },
      }

      this.$api.visit
          .lite(params)
          .then((response) => {
            this.visitsList = response.data.data;

            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    openConfirm(user) {
      this.dialogVisible = true
      this.activeUser = user
    },
    goVisit() {

      this.dialogVisible = false
      this.selectUser = this.activeUser
      this.openSessionModal = true


    },
    openSession(session) {

      this.setSession(session);

      if (session.stage === 10) this.$router.push({name: "session.card"})
      if (session.stage === 20) this.$router.push({name: "session.card"})
      if (session.stage === 30) this.$router.push({name: "session.questionnaire"})
      if (session.stage === 40) this.$router.push({name: "session.device"})
      if (session.stage === 50) {
        this.$notify.error({
          title: "Что-то пошло не так",
          message: "Данная сесия была закрыта",
        });
        this.$router.push("dashboard")
      }
    },
    openModalCurrentSession() {
      this.$alert('У вас имеется текущая активная сессия, завершите ее что бы взять в работу другую.', 'Имеется открытая сессия', {
        confirmButtonText: 'Перейти к текущей сесии',
        callback: () => {
          this.$router.push({name: 'session.create'})
        }
      });
    },
    loadDepartments() {
      this.pageLoading(true)

      this.$api.session
          .getDepartments('lite')
          .then((response) => {
            this.departmentList = response.data
            //

            this.selectDepartment = response.data[0]
            this.loadVisitList()

          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.pageLoading(false)
          });
    },
    closeSession() {
      this.visibleCloseSessionModal = !!1
    },
    editPagination(id) {
      console.log('editPagination', id)
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.title {
  font-size: 17px;
  line-height: 22px;
  color: #111;
  margin-top: 30px;
  font-weight: normal;
}

.filters {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-top: 20px;

  &__left {

  }

  &__right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  &__title {
    color: #8E8E93;
    font-size: 13px;
    line-height: 16px;
    padding: 0 5px;
  }
}

.box-card {
  margin-top: 20px;
}

.visits {
  margin: 0;
  padding-bottom: 20px;

  &__item {
    background-color: #f8f8f8;
    color: #303133;
    transition: 0.3s;
    margin: 0;
    overflow: hidden;

    display: flex;
    justify-content: space-between;
    align-items: center;

    max-width: 550px;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -1px rgba(0, 0, 0, .06);

    &:hover {
      box-shadow: 0 2px 8px 2px rgba(69, 90, 100, 0.28);
    }
  }

  &__options {
    color: #000;
    font-weight: 400;
    font-size: 16px !important;
    line-height: 26px;
    display: flex;
    width: 100%;

    @media screen and (max-width: 600px) {
      flex-direction: column;
    }

    &__header {
      h3 {
        margin: 0;
        color: #353c4e;
        letter-spacing: 3px;
      }

      margin: 15px 0 10px 0;
      padding-bottom: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      border-bottom: 1px solid #e0e0e0;
    }

    &__tag {
      margin-left: 10px;
    }

    & .left-content {
      width: 25px;

      background: linear-gradient(to right, #60f6c2, #54d5a8);
      padding: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      text-align: center;
      color: #fff;

      @media screen and (max-width: 600px) {
        padding: 10px 0;
        width: 100%;
        border-bottom-left-radius: 0;
      }

      & img {
        border-radius: 5px;
        margin-bottom: 10px;
      }

      & h4 {
        margin-bottom: 10px;
      }

      & p {
        font-size: 12px;
      }
    }

    & .right-content {
      width: 65%;
      padding: 0 25px 30px 25px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

      @media screen and (max-width: 600px) {
        width: 100%;
        padding: 0 0 0 15px;
        box-sizing: border-box;
      }

      &__info {
        margin-bottom: 25px;
      }

      &__info-data {
        display: flex;
        justify-content: space-between;
      }

      &__info-data .data {
        width: 45%;
      }

      &__info-data .data h4 {
        color: #353c4e;
        margin-bottom: 5px;
      }

      &__info-data .data p {
        font-size: 13px;
        margin-bottom: 10px;
        color: #919aa3;
      }
    }

    & .social_media ul {
      display: flex;
    }

    & .social_media ul li {
      width: 45px;
      height: 45px;
      background: linear-gradient(to right, #01a9ac, #01dbdf);
      margin-right: 10px;
      border-radius: 5px;
      text-align: center;
      line-height: 45px;
    }

    & .social_media ul li a {
      color: #fff;
      display: block;
      font-size: 18px;
    }
  }

  &__description {
    color: #ccc;
    font-size: 16px !important;
    line-height: 26px;
    display: inline;
  }

  &__time {
    color: #40c700;
    font-size: 16px !important;
    line-height: 26px;
  }

  &__worker {
    color: #747474;
    font-size: 16px !important;
    line-height: 26px;
  }

  &__btn {
    padding: 5px 6px;

    @media screen and (max-width: 600px) {
      float: none;
      margin: 0 auto 15px auto;
      display: block;
    }
  }
}

.page-buttons {
  margin: 25px auto;
  text-align: center;
}

.doctor {
  &__ava {
    width: 100px;
  }

  &__name {
    font-size: 16px;
  }

  &__contact {
    font-size: 13px;
  }

  &__gender {
    font-size: 12px;
    margin: 0;
  }
}

.pagination {
  margin-top: 10px;
}

.tip {
  margin: 30px 0;
}

.total {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #676767;

  &__count {
    font-weight: 500;
    color: #43D3B3;
  }
}

.zebra-table {
  margin-top: 20px;

  font-size: 15px;
  line-height: 16px;
  color: #676767;

  /deep/ .el-table__row {
    height: 60px;
  }
}

.user-data {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;

  &__name {
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;

    color: #111;
  }

  &__phone {
    margin-left: 8px;

    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 16px;

    color: #111;
  }
}

.edit-icon {
  color: #43D3B3;

  cursor: pointer;

  &:hover {
    opacity: 0.5
  }
}
</style>
